import React from 'react';
import { Card, CardBody } from '@heroui/react';
import { MdDangerous } from 'react-icons/md';
import { BiLineChart } from 'react-icons/bi';

// react-icons sometimes have typings that don't line up with strict JSX settings.
// Cast to a React component type to avoid TS2786 when used in JSX.
const MdDangerousIcon = (MdDangerous as unknown) as React.ComponentType<any>;
const BiLineChartIcon = (BiLineChart as unknown) as React.ComponentType<any>;

const ProblemSolution: React.FC = () => {
  return (
  <section id="problem" className="py-10 bg-white">
      <div className="w-60 h-1 bg-primary-gradient1 mx-auto mb-10" />
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary-dark mb-6">
            The Problem We Solve
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Modern businesses struggle with customer engagement. We provide the solution.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-2">
          {/* Problem Side */}
          <Card className="shadow-lg border-l-4 border-red-500">
            <CardBody className="p-8">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <MdDangerousIcon className="w-8 h-8 text-red-500" aria-hidden />
                </div>
                <h3 className="text-2xl font-bold text-red-600 mb-4">The Challenge</h3>
              </div>
              
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700">Manual review management takes hours every day</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700">Inconsistent brand voice in responses</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700">Lost customers due to delayed responses</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700">No systematic approach to customer recovery</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700">Missed opportunities for customer retention</p>
                </div>
              </div>
            </CardBody>
          </Card>
          
          {/* Solution Side */}
          <Card className="shadow-lg border-l-4 border-green-500">
            <CardBody className="p-8">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <BiLineChartIcon className="w-8 h-8 text-green-500" aria-hidden />
                </div>
                <h3 className="text-2xl font-bold text-green-600 mb-4">Our Solution</h3>
              </div>
              
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700">Automated 24/7 review monitoring and response</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700">AI-powered brand-consistent messaging</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700">Instant responses increase customer satisfaction</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700">Smart coupon generation for customer recovery</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700">Proven system increases customer lifetime value</p>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        
        {/* <div className="text-center bg-gradient-primary rounded-2xl p-8 text-white">
          <h3 className="text-3xl font-bold mb-4">
            Transform Your Customer Engagement Today
          </h3>
          <p className="text-xl text-white/90 mb-6">
            Join thousands of businesses that have revolutionized their customer experience with Aizora
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <div className="bg-white/20 rounded-lg p-4 backdrop-blur-sm">
              <div className="text-2xl font-bold">97%</div>
              <div className="text-sm text-white/80">Response Rate</div>
            </div>
            <div className="bg-white/20 rounded-lg p-4 backdrop-blur-sm">
              <div className="text-2xl font-bold">30s</div>
              <div className="text-sm text-white/80">Average Response Time</div>
            </div>
            <div className="bg-white/20 rounded-lg p-4 backdrop-blur-sm">
              <div className="text-2xl font-bold">25%</div>
              <div className="text-sm text-white/80">Customer Recovery Rate</div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default ProblemSolution;
